import { PAGE_TITLES } from "common/constants";
import { useLayoutEffect } from "react";
import { Outlet, useMatches } from "react-router-dom";

export const AppLayout = (): JSX.Element => {
  const matches = useMatches();
  const isNHDiagnostics = matches.some((m: any) => m.handle?.nhDiagnostics);
  const pageTitle = matches
    .map((m: any) => m.handle?.pageTitle)
    .filter(Boolean)
    .at(-1) as string | undefined;

  useLayoutEffect(() => {
    if (isNHDiagnostics) {
      document.title = PAGE_TITLES.NH_DIAGNOSTICS;
      return;
    }

    document.title = pageTitle ? `NH AIMS - ${pageTitle}` : PAGE_TITLES.AIMS;
  }, [isNHDiagnostics, pageTitle]);

  return <Outlet />;
};
